// Translations for English and French
export const translations = {
    en: {
        // Navigation
        dashboard: 'Dashboard',
        inventory: 'Inventory',
        products: 'Products',
        orders: 'Orders',
        returns: 'Returns',
        expenses: 'Expenses',
        financial: 'Financial',
        reports: 'Reports',
        users: 'Users',
        deliveryProviders: 'Delivery Providers',
        logout: 'Logout',

        // Common
        loading: 'Loading...',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        create: 'Create',
        add: 'Add',
        search: 'Search',
        filter: 'Filter',
        actions: 'Actions',
        status: 'Status',
        date: 'Date',
        total: 'Total',
        amount: 'Amount',
        name: 'Name',
        description: 'Description',
        price: 'Price',
        quantity: 'Quantity',
        all: 'All',
        none: 'None',
        yes: 'Yes',
        no: 'No',
        confirm: 'Confirm',
        close: 'Close',
        view: 'View',
        export: 'Export',
        download: 'Download',
        refresh: 'Refresh',
        settings: 'Settings',
        active: 'Active',
        inactive: 'Inactive',

        // Dashboard
        totalRevenue: 'Total Revenue',
        totalExpenses: 'Total Expenses',
        netProfit: 'Net Profit',
        totalOrders: 'Total Orders',
        pendingOrders: 'Pending Orders',
        lowStockItems: 'Low Stock Items',
        recentOrders: 'Recent Orders',
        salesOverview: 'Sales Overview',
        quickStats: 'Quick Stats',
        availableUnits: 'Available Units',
        orderedUnits: 'Ordered Units',
        deliveredUnits: 'Delivered Units',
        dashboardSubtitle: 'Overview of your inventory status',
        readyForSale: 'Ready for sale',
        awaitingDispatch: 'Awaiting dispatch',
        returnsQueue: 'Returns Queue',
        pendingInspection: 'Pending inspection',
        warehouseValue: 'Warehouse Value',
        totalCostBasis: 'Total cost basis',
        soldUnits: 'Sold Units',
        totalProducts: 'Total Products',
        damagedUnits: 'Damaged Units',
        inventoryStatusBreakdown: 'Inventory Status Breakdown',
        inventoryDistribution: 'Distribution of all {0} inventory units',
        inTransit: 'In Transit',
        damaged: 'Damaged',

        // Products
        productsSubtitle: 'Manage your product catalog',
        addProduct: 'Add Product',
        editProduct: 'Edit Product',
        newProduct: 'New Product',
        updateProductDesc: 'Update product details',
        addProductDesc: 'Add a new product to your catalog',
        productName: 'Product Name',
        placeholderProduct: 'Product name',
        sku: 'SKU',
        placeholderSku: 'e.g. PROD-001',
        category: 'Category',
        selectCategory: 'Select a category',
        newCategory: 'New Category',
        addCategoryDesc: 'Add a new product category',
        categoryName: 'Category Name',
        placeholderCategory: 'e.g. Electronics',
        createCategory: 'Create Category',
        lowStockThreshold: 'Low Stock Threshold',
        stock: 'Stock',
        noProducts: 'No products yet. Create your first product above.',
        available: 'available',
        ordered: 'ordered',
        deleteProductConfirm: 'Are you sure you want to delete this product?',
        cannotDeleteProductTitle: 'This Product Cannot Be Deleted',
        cannotDeleteProductMsg: 'This product has operational history that must be preserved for financial and inventory records.',
        cannotDeleteProductReason: 'Deleting it would permanently destroy:',
        cannotDeleteReasonUnits: '{0} inventory unit(s) — current or past stock entries',
        cannotDeleteReasonTransactions: '{0} transaction(s) — buy/sell/return history used in financial reports',
        cannotDeleteReasonOrders: 'Order history linked to those units',
        archiveInstead: 'Archive the product instead',
        archiveInsteadDesc: 'Archiving hides the product from active use (no new stock can be added) while keeping all history intact. This is the recommended approach.',
        archiveProduct: 'Archive Product',
        restoreProduct: 'Restore Product',
        archiveProductConfirm: 'Archive this product? It will be hidden from active use but all history will be preserved.',
        restoreProductConfirm: 'Restore this product? It will become active again.',
        productArchived: 'Product archived successfully',
        productRestored: 'Product restored successfully',
        archived: 'Archived',
        showArchived: 'Show Archived',
        hideArchived: 'Hide Archived',
        viewInInventory: 'View in Inventory',

        // Inventory
        addUnit: 'Add Unit',
        addUnits: 'Add Units',
        addInventoryUnits: 'Add Inventory Units',
        addInventorySubtitle: 'Add new units to your inventory with buy price',
        bulkAdd: 'Bulk Add',
        serialNumber: 'Serial Number',
        color: 'Color',
        purchasePrice: 'Purchase Price',
        buyPrice: 'Buy Price',
        costBasis: 'Cost Basis',
        sellPrice: 'Sell Price',
        supplier: 'Supplier',
        noUnits: 'No inventory units found. Add units using the button above.',
        unitStatus: 'Unit Status',
        available: 'Available',
        ordered: 'Ordered',
        pendingDelivery: 'Pending Delivery',
        dispatched: 'Dispatched',
        delivered: 'Delivered',
        returned: 'Returned',
        sold: 'Sold',
        inventorySubtitle: 'Track individual inventory units',
        allStatuses: 'All Statuses',
        allProducts: 'All Products',
        unitUuid: 'Unit UUID',
        notes: 'Notes',
        notesPlaceholder: 'Batch info, supplier, etc.',
        selectProduct: 'Select a product',
        created: 'Created',
        filters: 'Filters',
        searchInventory: 'Search by UUID, product name or SKU...',
        dateFrom: 'Date From',
        dateTo: 'Date To',
        minPrice: 'Min Price',
        maxPrice: 'Max Price',
        clearFilters: 'Clear Filters',
        buyStock: 'Buy Stock',
        sellStock: 'Sell Stock',
        buyStockDesc: 'Purchase new inventory units and log expense',
        sellStockDesc: 'Directly sell available units across multiple products',
        confirmBuyStock: 'Confirm Purchase',
        confirmBuyStockMsg: 'This will add {quantity} units of {productName} to inventory and create an expense of {amount} TND. Proceed?',
        confirmSellStock: 'Confirm Bulk Sale',
        confirmSellStockMsg: 'This will sell {quantity} total units and generate {amount} TND in immediate revenue. Proceed?',
        addAnotherProduct: 'Add Another Product',
        directSale: 'Direct Sale',

        // Orders
        createOrder: 'Create Order',
        newOrder: 'New Order',
        ordersSubtitle: 'Manage customer orders and track delivery status',
        createNewOrder: 'Create New Order',
        createNewOrderSubtitle: 'Select inventory units and enter customer details',
        customerName: 'Customer Name',
        customerPhone: 'Phone',
        customerAddress: 'Address',
        governorate: 'Governorate (City)',
        selectGovernorate: 'Select governorate',
        district: 'District/Delegation',
        deliveryFee: 'Delivery Fee (TND)',
        selectUnits: 'Select Units',
        selectedCount: '({0} selected)',
        noOrders: 'No orders found. Create your first order above.',
        orderNumber: 'Order #',
        items: 'Items',
        unitCount: '{0} unit(s)',
        dispatch: 'Dispatch',
        markDelivered: 'Mark Delivered',
        markReturned: 'Mark Returned',
        cancel: 'Cancel',
        confirmCancel: 'Are you sure you want to cancel this order?',
        pending: 'Pending',
        confirmed: 'Confirmed',
        dispatched: 'Dispatched',
        delivered: 'Delivered',
        returned: 'Returned',
        cancelled: 'Cancelled',
        trackingId: 'Tracking ID',
        syncIntigo: 'Sync Intigo',
        syncing: 'Syncing...',
        syncSuccess: 'Intigo synchronization complete',
        syncFailed: 'Failed to sync with Intigo',

        // Order Wizard
        step: 'Step',
        of: 'of',
        selectProducts: 'Select Products',
        setPrices: 'Set Prices',
        customerDetails: 'Customer Details',
        confirmation: 'Confirmation',
        searchProducts: 'Search products...',
        noProductsFound: 'No products found',
        itemsSelected: 'item(s) selected',
        individualPricing: 'Individual Pricing',
        totalPricing: 'Total Price',
        totalOrderPrice: 'Total Order Price',
        apply: 'Apply',
        subtotal: 'Subtotal',
        orderItems: 'Order Items',
        customerInfo: 'Customer Info',
        orderTotal: 'Order Total',
        total: 'Total',
        edit: 'Edit',
        back: 'Back',
        next: 'Next',

        // Returns
        returnsInspection: 'Returns & Inspection',
        processReturns: 'Process returned items through the inspection gate',
        createReturn: 'Create Return',
        returnReason: 'Return Reason',
        selectOrder: 'Select Order',
        noReturns: 'No returns found',
        returnStatus: 'Return Status',
        processing: 'Processing',
        completed: 'Completed',
        itemsInQuarantine: 'Items in quarantine',
        quarantineQueue: 'Quarantine Queue',
        quarantineQueueSubtitle: 'Returned items awaiting inspection',
        noQuarantineItems: 'No items in quarantine',
        quarantineEmpty: 'Returned items will appear here for inspection',
        approve: 'Approve',
        reject: 'Reject',
        approveItem: 'Approve Item',
        approveDescription: 'This will return the item to available stock (AVAILABLE status).',
        confirmApproval: 'Confirm Approval',
        rejectItem: 'Reject Item',
        rejectDescription: 'This will mark the item as damaged and write it off (DAMAGED status).',
        confirmRejection: 'Confirm Rejection',
        damageReason: 'Damage Reason',
        damageReasonPlaceholder: 'e.g., Water damage, Broken screen...',
        notesOptional: 'Notes (optional)',
        inspectionNotes: 'Any inspection notes...',
        serial: 'Serial',
        order: 'Order',
        customer: 'Customer',
        product: 'Product',
        returnedAt: 'Returned At',

        // Expenses
        expenseTracking: 'Expense Tracking',
        expenseTrackingSubtitle: 'Manage company expenses and payments',
        addExpense: 'Add Expense',
        editExpense: 'Edit Expense',
        addNewExpense: 'Add New Expense',
        registerExpense: 'Register a new company expense',
        updateExpense: 'Update Expense',
        updateExpenseDetails: 'Update expense details',
        vendor: 'Vendor / Payee',
        reference: 'Reference / Invoice #',
        dueDate: 'Due Date',
        markPaid: 'Mark as Paid',
        totalPending: 'Total Pending',
        unpaidInvoices: 'Unpaid invoices',
        paidLast30Days: 'Paid (Last 30 Days)',
        settledExpenses: 'Settled expenses',
        overdue: 'Overdue',
        pastDueDate: 'Past due date',
        searchExpenses: 'Search expenses...',
        allCategories: 'All Categories',
        fillRequired: 'Please fill in all required fields (Description, Amount, Category)',
        confirmDeleteExpense: 'Are you sure you want to delete this expense?',

        expenseCategory: 'Category',
        expenseAmount: 'Amount',
        expenseDate: 'Date',
        expenseDescription: 'Description',
        recurring: 'Recurring',
        paid: 'Paid',
        noExpenses: 'No expenses found',
        categories: 'Categories',
        addCategory: 'Add Category',
        expenseCategoryManagement: 'Expense Categories',
        manageCategoriesSubtitle: 'Organize and manage your expense categories',
        addNewCategory: 'Add New Category',
        createNewCategory: 'Create a new expense category',
        editCategory: 'Edit Category',
        updateCategory: 'Update Category',
        updateCategoryDetails: 'Update category information',
        categoryNameRequired: 'Category name is required',
        categoryCreated: 'Category created successfully',
        categoryUpdated: 'Category updated successfully',
        categoryDeleted: 'Category deleted successfully',
        failedSaveCategory: 'Failed to save category',
        failedDeleteCategory: 'Failed to delete category',
        failedFetchCategories: 'Failed to fetch categories',
        noCategories: 'No categories found',
        placeholderCategoryName: 'e.g. Office Supplies',
        placeholderCategoryDesc: 'e.g. Office supplies and equipment',
        color: 'Color',

        // Financial
        financialDashboard: 'Financial Dashboard',
        financialOverview: 'Overview of income and expenses',
        downloadReport: 'Download PDF Report',
        startDate: 'Start Date',
        endDate: 'End Date',
        apply: 'Apply',

        financialSummary: 'Financial Summary',
        income: 'Income',
        profitMargin: 'Profit Margin',
        monthlyOverview: 'Monthly Overview',
        expensesByCategory: 'Expenses by Category',

        expensesTitle: 'Expenses',
        netProfit: 'Net Profit',
        pendingExpenses: 'Pending',
        unpaidExpenses: 'Unpaid expenses',
        incomeMinusExpenses: 'Income - Expenses',
        transactions: 'Transactions',
        type: 'Type',
        noTransactions: 'No transactions found for this period',
        downloadFailed: 'Failed to download report',
        ordersDeliveredCount: '{0} orders delivered',
        expensesCount: '{0} expenses',

        // Reports
        // Reports
        reportsTitle: 'Reports & Analytics',
        reportsSubtitle: 'Track sales performance and profit margins',
        last7days: 'Last 7 days',
        last30days: 'Last 30 days',
        last90days: 'Last 90 days',
        lastYear: 'Last year',
        totalSales: 'Total Sales',
        revenueGenerated: 'Revenue generated',
        ordersPlaced: 'Orders Placed',
        volume: 'Volume',
        avgOrderValue: 'Avg. Order Value',
        profitability: 'Profitability',
        topProducts: 'Top Products',
        byRevenue: 'By Revenue',
        rank: 'Rank',
        soldInfo: 'Sold',
        revenue: 'Revenue',
        salesTrend: 'Sales Trend',
        generateReport: 'Generate Report',
        reportType: 'Report Type',
        dateRange: 'Date Range',
        startDate: 'Start Date',
        endDate: 'End Date',
        salesReport: 'Sales Report',
        inventoryReport: 'Inventory Report',
        financialReport: 'Financial Report',
        downloadPdf: 'Download PDF',
        downloadCsv: 'Download CSV',
        noDataAvailable: 'No data available for this period',
        units: 'units',

        // Users
        // Users
        userManagement: 'User Management',
        userManagementSubtitle: 'Manage staff accounts and permissions',
        totalUsers: 'Total Users',
        admins: 'Admins',
        allUsers: 'All Users',
        staffAccounts: 'Staff accounts and their roles',
        saveChanges: 'Save Changes',
        fullName: 'Full Name',
        editUser: 'Edit User',
        updateUserDesc: 'Update user details below.',
        createUserDesc: 'Add a new staff member to the system.',

        // Roles
        warehouseStaff: 'Warehouse Staff',
        orderConfirmation: 'Order Confirmation',
        accountant: 'Accountant',
        typeA: 'Type A',

        addUser: 'Add User',
        username: 'Username',
        email: 'Email',
        password: 'Password',
        newPassword: 'New Password',
        leaveBlankToKeep: 'Leave blank to keep current password',
        role: 'Role',
        admin: 'Admin',
        staff: 'Staff',
        active: 'Active',
        inactive: 'Inactive',
        noUsers: 'No users found',

        // Delivery Providers
        deliveryProvidersSubtitle: 'Manage integration with courier services',
        providersList: 'Providers List',
        configuredProviders: 'Configured courier integrations',
        default: 'Default',
        test: 'Test',
        editProvider: 'Edit Provider',
        newProvider: 'New Provider',
        configureProvider: 'Configure provider settings',
        addProviderDesc: 'Add a new courier integration',
        webhookSecret: 'Webhook Secret',
        pickupInfo: 'Pickup Information',
        createProvider: 'Create Provider',
        commonSettings: 'Common Settings',
        successTest: 'Connection test successful',
        failedTest: 'Connection test failed',
        errorSaveProvider: 'Failed to save provider',
        confirmDeleteProvider: 'Are you sure you want to delete this provider?',
        addProvider: 'Add Provider',
        providerName: 'Provider Name',
        providerType: 'Provider Type',
        apiKey: 'API Key',
        apiUrl: 'API URL',
        pickupAddress: 'Pickup Address',
        pickupGovernorate: 'Pickup Governorate',
        pickupSubdivision: 'Pickup Subdivision',
        testConnection: 'Test Connection',
        setDefault: 'Set as Default',
        defaultProvider: 'Default Provider',
        connected: 'Connected',
        failed: 'Failed',

        // Login
        appName: 'Stock Management',
        loginSubtitle: 'Sign in to access the inventory system',
        signIn: 'Sign In',
        signingIn: 'Signing in...',
        login: 'Login',
        welcomeBack: 'Welcome Back',
        enterCredentials: 'Enter your credentials to access your account',
        rememberMe: 'Remember me',
        forgotPassword: 'Forgot password?',

        // Messages
        successCreated: 'Successfully created',
        successUpdated: 'Successfully updated',
        successDeleted: 'Successfully deleted',
        errorOccurred: 'An error occurred',
        confirmDelete: 'Are you sure you want to delete this?',
    },

    fr: {
        // Navigation
        dashboard: 'Tableau de bord',
        inventory: 'Inventaire',
        products: 'Produits',
        orders: 'Commandes',
        returns: 'Retours',
        expenses: 'Dépenses',
        financial: 'Finances',
        reports: 'Rapports',
        users: 'Utilisateurs',
        deliveryProviders: 'Transporteurs',
        logout: 'Déconnexion',

        // Common
        loading: 'Chargement...',
        save: 'Enregistrer',
        cancel: 'Annuler',
        delete: 'Supprimer',
        edit: 'Modifier',
        create: 'Créer',
        add: 'Ajouter',
        search: 'Rechercher',
        filter: 'Filtrer',
        actions: 'Actions',
        status: 'Statut',
        date: 'Date',
        total: 'Total',
        amount: 'Montant',
        name: 'Nom',
        description: 'Description',
        price: 'Prix',
        quantity: 'Quantité',
        all: 'Tous',
        none: 'Aucun',
        yes: 'Oui',
        no: 'Non',
        confirm: 'Confirmer',
        close: 'Fermer',
        view: 'Voir',
        export: 'Exporter',
        download: 'Télécharger',
        refresh: 'Actualiser',
        settings: 'Paramètres',
        active: 'Actif',
        inactive: 'Inactif',

        // Dashboard
        totalRevenue: 'Revenu Total',
        totalExpenses: 'Dépenses Totales',
        netProfit: 'Bénéfice Net',
        totalOrders: 'Total Commandes',
        pendingOrders: 'Commandes en Attente',
        lowStockItems: 'Stock Faible',
        recentOrders: 'Commandes Récentes',
        salesOverview: 'Aperçu des Ventes',
        quickStats: 'Statistiques',
        availableUnits: 'Unités Disponibles',
        orderedUnits: 'Unités Commandées',
        deliveredUnits: 'Unités Livrées',
        dashboardSubtitle: 'Aperçu de l\'état de votre inventaire',
        readyForSale: 'Prêt à la vente',
        awaitingDispatch: 'En attente d\'expédition',
        returnsQueue: 'File des retours',
        pendingInspection: 'Inspection en attente',
        warehouseValue: 'Valeur de l\'entrepôt',
        totalCostBasis: 'Base de coût total',
        soldUnits: 'Unités Vendues',
        totalProducts: 'Total Produits',
        damagedUnits: 'Unités Endommagées',
        inventoryStatusBreakdown: 'Répartition de l\'inventaire',
        inventoryDistribution: 'Distribution de toutes les {0} unités',
        inTransit: 'En Transit',
        damaged: 'Endommagé',

        // Products
        productsSubtitle: 'Gérer votre catalogue produits',
        addProduct: 'Ajouter Produit',
        editProduct: 'Modifier Produit',
        newProduct: 'Nouveau Produit',
        updateProductDesc: 'Mettre à jour les détails du produit',
        addProductDesc: 'Ajouter un nouveau produit à votre catalogue',
        productName: 'Nom du Produit',
        placeholderProduct: 'Nom du produit',
        sku: 'SKU',
        placeholderSku: 'ex: PROD-001',
        category: 'Catégorie',
        selectCategory: 'Sélectionner une catégorie',
        newCategory: 'Nouvelle Catégorie',
        addCategoryDesc: 'Ajouter une nouvelle catégorie de produits',
        categoryName: 'Nom de la Catégorie',
        placeholderCategory: 'ex: Électronique',
        createCategory: 'Créer Catégorie',
        lowStockThreshold: 'Seuil Stock Faible',
        stock: 'Stock',
        noProducts: 'Aucun produit. Créez votre premier produit ci-dessus.',
        available: 'disponible',
        ordered: 'commandé',
        deleteProductConfirm: 'Êtes-vous sûr de vouloir supprimer ce produit ?',
        cannotDeleteProductTitle: 'Ce produit ne peut pas être supprimé',
        cannotDeleteProductMsg: 'Ce produit a un historique opérationnel qui doit être conservé pour les dossiers financiers et d\'inventaire.',
        cannotDeleteProductReason: 'Le supprimer détruirait définitivement :',
        cannotDeleteReasonUnits: '{0} unité(s) d\'inventaire — entrées de stock actuelles ou passées',
        cannotDeleteReasonTransactions: '{0} transaction(s) — historique d\'achat/vente/retour utilisé dans les rapports financiers',
        cannotDeleteReasonOrders: 'L\'historique des commandes liées à ces unités',
        archiveInstead: 'Archiver le produit à la place',
        archiveInsteadDesc: 'L\'archivage masque le produit de l\'utilisation active (aucun nouveau stock ne peut être ajouté) tout en conservant tout l\'historique. C\'est l\'approche recommandée.',
        archiveProduct: 'Archiver le Produit',
        restoreProduct: 'Restaurer le Produit',
        archiveProductConfirm: 'Archiver ce produit ? Il sera masqué de l\'utilisation active mais tout l\'historique sera préservé.',
        restoreProductConfirm: 'Restaurer ce produit ? Il redeviendra actif.',
        productArchived: 'Produit archivé avec succès',
        productRestored: 'Produit restauré avec succès',
        archived: 'Archivé',
        showArchived: 'Afficher les archivés',
        hideArchived: 'Masquer les archivés',
        viewInInventory: 'Voir dans l\'Inventaire',

        // Inventory
        addUnit: 'Ajouter Unité',
        addUnits: 'Ajouter Unités',
        addInventoryUnits: 'Ajouter des Unités d\'Inventaire',
        addInventorySubtitle: 'Ajouter de nouvelles unités à votre inventaire avec prix d\'achat',
        bulkAdd: 'Ajout en Masse',
        serialNumber: 'Numéro de Série',
        color: 'Couleur',
        purchasePrice: "Prix d'Achat",
        buyPrice: 'Prix d\'Achat',
        costBasis: 'Base de Coût',
        sellPrice: 'Prix de Vente',
        supplier: 'Fournisseur',
        noUnits: "Aucune unité d'inventaire trouvée. Ajoutez des unités en utilisant le bouton ci-dessus.",
        unitStatus: "Statut de l'Unité",
        available: 'Disponible',
        ordered: 'Commandé',
        pendingDelivery: 'Livraison en attente',
        dispatched: 'Expédié',
        delivered: 'Livré',
        returned: 'Retourné',
        sold: 'Vendu',
        inventorySubtitle: 'Suivre les unités d\'inventaire individuelles',
        allStatuses: 'Tous les Statuts',
        allProducts: 'Tous les Produits',
        unitUuid: 'UUID Unité',
        notes: 'Notes',
        notesPlaceholder: 'Info lot, fournisseur, etc.',
        selectProduct: 'Sélectionner un produit',
        created: 'Créé le',
        filters: 'Filtres',
        searchInventory: 'Rechercher par UUID, nom ou SKU...',
        dateFrom: 'Date de début',
        dateTo: 'Date de fin',
        minPrice: 'Prix Min',
        maxPrice: 'Prix Max',
        clearFilters: 'Effacer les Filtres',
        buyStock: 'Acheter Stock',
        sellStock: 'Vendre Stock',
        buyStockDesc: 'Acheter de nouvelles unités et enregistrer la dépense',
        sellStockDesc: 'Vendre directement des unités disponibles (plusieurs produits)',
        confirmBuyStock: 'Confirmer l\'Achat',
        confirmBuyStockMsg: 'Ceci ajoutera {quantity} unités de {productName} à l\'inventaire et créera une dépense de {amount} TND. Continuer ?',
        confirmSellStock: 'Confirmer la Vente',
        confirmSellStockMsg: 'Ceci vendra un total de {quantity} unités et générera {amount} TND de revenus immédiats. Continuer ?',
        addAnotherProduct: 'Ajouter un autre produit',
        directSale: 'Vente Directe',

        // Orders
        createOrder: 'Créer Commande',
        newOrder: 'Nouvelle Commande',
        ordersSubtitle: 'Gérer les commandes clients et suivre le statut de livraison',
        createNewOrder: 'Créer Nouvelle Commande',
        createNewOrderSubtitle: 'Sélectionner des unités et entrer les détails client',
        customerName: 'Nom du Client',
        customerPhone: 'Téléphone',
        customerAddress: 'Adresse',
        governorate: 'Gouvernorat (Ville)',
        selectGovernorate: 'Sélectionner Gouvernorat',
        district: 'Délégation',
        deliveryFee: 'Frais de Livraison (TND)',
        selectUnits: 'Sélectionner Unités',
        selectedCount: '({0} sélectionné(s))',
        noOrders: 'Aucune commande trouvée. Créez votre première commande ci-dessus.',
        orderNumber: 'Numéro de Commande',
        items: 'Articles',
        unitCount: '{0} unité(s)',
        dispatch: 'Expédier',
        markDelivered: 'Marquer Livré',
        markReturned: 'Marquer Retourné',
        cancel: 'Annuler',
        confirmCancel: 'Êtes-vous sûr de vouloir annuler cette commande ?',
        pending: 'En attente',
        confirmed: 'Confirmé',
        dispatched: 'Expédié',
        delivered: 'Livré',
        returned: 'Retourné',
        cancelled: 'Annulé',
        trackingId: 'Numéro de Suivi',
        syncIntigo: 'Sync Intigo',
        syncing: 'Sync en cours...',
        syncSuccess: 'Synchronisation Intigo terminée',
        syncFailed: 'Échec de synchronisation avec Intigo',

        // Order Wizard
        step: 'Étape',
        of: 'sur',
        selectProducts: 'Sélectionner Produits',
        setPrices: 'Définir les Prix',
        customerDetails: 'Détails Client',
        confirmation: 'Confirmation',
        searchProducts: 'Rechercher des produits...',
        noProductsFound: 'Aucun produit trouvé',
        itemsSelected: 'article(s) sélectionné(s)',
        individualPricing: 'Prix Individuel',
        totalPricing: 'Prix Total',
        totalOrderPrice: 'Prix Total de la Commande',
        apply: 'Appliquer',
        subtotal: 'Sous-total',
        orderItems: 'Articles de la Commande',
        customerInfo: 'Infos Client',
        orderTotal: 'Total de la Commande',
        total: 'Total',
        edit: 'Modifier',
        back: 'Retour',
        next: 'Suivant',

        // Returns
        returnsInspection: 'Retours & Inspection',
        processReturns: 'Traiter les articles retournés via le portail d\'inspection',
        createReturn: 'Créer Retour',
        returnReason: 'Raison du Retour',
        selectOrder: 'Sélectionner Commande',
        noReturns: 'Aucun retour trouvé',
        returnStatus: 'Statut du Retour',
        processing: 'En cours',
        completed: 'Terminé',
        itemsInQuarantine: 'Articles en quarantaine',
        quarantineQueue: 'File de Quarantaine',
        quarantineQueueSubtitle: 'Articles retournés en attente d\'inspection',
        noQuarantineItems: 'Aucun article en quarantaine',
        quarantineEmpty: 'Les articles retournés apparaîtront ici pour inspection',
        approve: 'Approuver',
        reject: 'Rejeter',
        approveItem: 'Approuver Article',
        approveDescription: 'Ceci retournera l\'article au stock disponible (statut DISPONIBLE).',
        confirmApproval: 'Confirmer Approbation',
        rejectItem: 'Rejeter Article',
        rejectDescription: 'Ceci marquera l\'article comme endommagé et le passera en perte (statut ENDOMMAGÉ).',
        confirmRejection: 'Confirmer Rejet',
        damageReason: 'Raison du Dommage',
        damageReasonPlaceholder: 'ex: Dégâts des eaux, Écran cassé...',
        notesOptional: 'Notes (optionnel)',
        inspectionNotes: 'Notes d\'inspection...',
        serial: 'Série',
        order: 'Commande',
        customer: 'Client',
        product: 'Produit',
        returnedAt: 'Retourné le',

        // Expenses
        expenseTracking: 'Suivi des Dépenses',
        expenseTrackingSubtitle: 'Gérer les dépenses de l\'entreprise et les paiements',
        addExpense: 'Ajouter Dépense',
        editExpense: 'Modifier Dépense',
        addNewExpense: 'Ajouter Nouvelle Dépense',
        registerExpense: 'Enregistrer une nouvelle dépense',
        updateExpense: 'Mettre à jour Dépense',
        updateExpenseDetails: 'Mettre à jour les détails',
        vendor: 'Vendeur / Bénéficiaire',
        reference: 'Référence / Facture #',
        dueDate: 'Date d\'échéance',
        markPaid: 'Marquer comme Payé',
        totalPending: 'Total En Attente',
        unpaidInvoices: 'Factures impayées',
        paidLast30Days: 'Payé (30 derniers jours)',
        settledExpenses: 'Dépenses réglées',
        overdue: 'En Retard',
        pastDueDate: 'Date d\'échéance passée',
        searchExpenses: 'Rechercher dépenses...',
        allCategories: 'Toutes Catégories',
        fillRequired: 'Veuillez remplir tous les champs obligatoires',
        confirmDeleteExpense: 'Êtes-vous sûr de vouloir supprimer cette dépense ?',

        expenseCategory: 'Catégorie',
        expenseAmount: 'Montant',
        expenseDate: 'Date',
        expenseDescription: 'Description',
        recurring: 'Récurrent',
        paid: 'Payé',
        noExpenses: 'Aucune dépense trouvée',
        categories: 'Catégories',
        addCategory: 'Ajouter Catégorie',
        expenseCategoryManagement: 'Catégories de Dépenses',
        manageCategoriesSubtitle: 'Organisez et gérez vos catégories de dépenses',
        addNewCategory: 'Ajouter Nouvelle Catégorie',
        createNewCategory: 'Créer une nouvelle catégorie de dépenses',
        editCategory: 'Modifier Catégorie',
        updateCategory: 'Mettre à jour',
        updateCategoryDetails: 'Mettre à jour les informations de la catégorie',
        categoryNameRequired: 'Le nom de la catégorie est obligatoire',
        categoryCreated: 'Catégorie créée avec succès',
        categoryUpdated: 'Catégorie mise à jour avec succès',
        categoryDeleted: 'Catégorie supprimée avec succès',
        failedSaveCategory: 'Échec de la sauvegarde de la catégorie',
        failedDeleteCategory: 'Échec de la suppression de la catégorie',
        failedFetchCategories: 'Échec de la récupération des catégories',
        noCategories: 'Aucune catégorie trouvée',
        placeholderCategoryName: 'ex. Fournitures de Bureau',
        placeholderCategoryDesc: 'ex. Fournitures et équipements de bureau',
        color: 'Couleur',

        // Financial
        financialDashboard: 'Tableau Financier',
        financialOverview: 'Vue d\'ensemble des revenus et dépenses',
        downloadReport: 'Télécharger Rapport PDF',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        apply: 'Appliquer',

        financialSummary: 'Résumé Financier',
        income: 'Revenus',
        profitMargin: 'Marge Bénéficiaire',
        monthlyOverview: 'Aperçu Mensuel',
        expensesByCategory: 'Dépenses par Catégorie',

        expensesTitle: 'Dépenses',
        netProfit: 'Bénéfice Net',
        pendingExpenses: 'En Attente',
        unpaidExpenses: 'Dépenses non payées',
        incomeMinusExpenses: 'Revenus - Dépenses',
        transactions: 'Transactions',
        type: 'Type',
        noTransactions: 'Aucune transaction trouvée pour cette période',
        downloadFailed: 'Échec du téléchargement du rapport',
        ordersDeliveredCount: '{0} commandes livrées',
        expensesCount: '{0} dépenses',

        // Reports
        // Reports
        reportsTitle: 'Rapports & Analytique',
        reportsSubtitle: 'Suivre les performances des ventes et les marges',
        last7days: '7 derniers jours',
        last30days: '30 derniers jours',
        last90days: '90 derniers jours',
        lastYear: 'Année dernière',
        totalSales: 'Ventes Totales',
        revenueGenerated: 'Revenus générés',
        ordersPlaced: 'Commandes passées',
        volume: 'Volume',
        avgOrderValue: 'Val. Moyenne',
        profitability: 'Rentabilité',
        topProducts: 'Meilleurs Produits',
        byRevenue: 'Par Revenus',
        rank: 'Rang',
        soldInfo: 'Vendu',
        revenue: 'Revenus',
        salesTrend: 'Tendance des Ventes',
        generateReport: 'Générer Rapport',
        reportType: 'Type de Rapport',
        dateRange: 'Période',
        startDate: 'Date de Début',
        endDate: 'Date de Fin',
        salesReport: 'Rapport des Ventes',
        inventoryReport: "Rapport d'Inventaire",
        financialReport: 'Rapport Financier',
        downloadPdf: 'Télécharger PDF',
        downloadCsv: 'Télécharger CSV',
        noDataAvailable: 'Aucune donnée disponible pour cette période',
        units: 'unités',

        // Users
        // Users
        userManagement: 'Gestion des Utilisateurs',
        userManagementSubtitle: 'Gérer les comptes du personnel et les permissions',
        totalUsers: 'Total Utilisateurs',
        admins: 'Admins',
        allUsers: 'Tous les Utilisateurs',
        staffAccounts: 'Comptes du personnel et leurs rôles',
        saveChanges: 'Enregistrer les modifications',
        fullName: 'Nom Complet',
        editUser: "Modifier l'utilisateur",
        updateUserDesc: "Mettez à jour les détails de l'utilisateur ci-dessous.",
        createUserDesc: "Ajouter un nouveau membre du personnel au système.",

        // Roles
        warehouseStaff: 'Personnel d\'Entrepôt',
        orderConfirmation: 'Confirmation de Commande',
        accountant: 'Comptable',
        typeA: 'Type A',

        addUser: 'Ajouter Utilisateur',
        username: "Nom d'utilisateur",
        email: 'Email',
        password: 'Mot de passe',
        newPassword: 'Nouveau Mot de passe',
        leaveBlankToKeep: 'Laisser vide pour conserver le mot de passe actuel',
        role: 'Rôle',
        admin: 'Administrateur',
        staff: 'Personnel',
        active: 'Actif',
        inactive: 'Inactif',
        noUsers: 'Aucun utilisateur trouvé',

        // Delivery Providers
        deliveryProvidersSubtitle: 'Gérer l\'intégration avec les services de livraison',
        providersList: 'Liste des Transporteurs',
        configuredProviders: 'Intégrations de transporteurs configurés',
        default: 'Défaut',
        test: 'Tester',
        editProvider: 'Modifier Transporteur',
        newProvider: 'Nouveau Transporteur',
        configureProvider: 'Configurer les paramètres du transporteur',
        addProviderDesc: 'Ajouter une nouvelle intégration',
        webhookSecret: 'Secret Webhook',
        pickupInfo: 'Informations de Ramassage',
        createProvider: 'Créer Transporteur',
        commonSettings: 'Paramètres Communs',
        successTest: 'Test de connexion réussi',
        failedTest: 'Échec du test de connexion',
        errorSaveProvider: 'Échec de l\'enregistrement du transporteur',
        confirmDeleteProvider: 'Êtes-vous sûr de vouloir supprimer ce transporteur ?',
        addProvider: 'Ajouter Transporteur',
        providerName: 'Nom du Transporteur',
        providerType: 'Type',
        apiKey: 'Clé API',
        apiUrl: 'URL API',
        pickupAddress: 'Adresse de Ramassage',
        pickupGovernorate: 'Gouvernorat de Ramassage',
        pickupSubdivision: 'Délégation de Ramassage',
        testConnection: 'Tester Connexion',
        setDefault: 'Définir par Défaut',
        defaultProvider: 'Transporteur par Défaut',
        connected: 'Connecté',
        failed: 'Échec',

        // Login
        appName: 'Gestion de Stock',
        loginSubtitle: 'Connectez-vous pour accéder au système d\'inventaire',
        signIn: 'Se Connecter',
        signingIn: 'Connexion en cours...',
        login: 'Connexion',
        welcomeBack: 'Bienvenue',
        enterCredentials: 'Entrez vos identifiants pour accéder à votre compte',
        rememberMe: 'Se souvenir de moi',
        forgotPassword: 'Mot de passe oublié?',

        // Messages
        successCreated: 'Créé avec succès',
        successUpdated: 'Mis à jour avec succès',
        successDeleted: 'Supprimé avec succès',
        errorOccurred: 'Une erreur est survenue',
        confirmDelete: 'Êtes-vous sûr de vouloir supprimer ceci?',
    }
};
